
import styles from './index.module.css';

import qrcode from './images/qrcode.png';

const text = {
    cn: {
        title: '联系我们',
        map: [
            {
                label: '地址',
                value: '16 Barrister Ln, Manalapan, NJ, US 07726',
            },
            {
                label: '电话',
                value: '1-732-908-9121/8618310012262',
            },
            {
                label: '邮箱',
                value: 'lisahsu914@me.com',
            },
        ],
        callus: '关注我们:'
    },
    en: {
        title: 'CONTACT US',
        map: [
            {
                label: 'Address',
                value: '16 Barrister Ln, Manalapan, NJ, US 07726',
            },
            {
                label: 'Phone',
                value: '1-732-908-9121/8618310012262',
            },
            {
                label: 'Email',
                value: 'lisahsu914@me.com',
            },
        ],
        callus: 'Follow us:'
    },
}

const Fotter = (props) => {
    const { l } = props;
    return (
        <div className={styles['content']}>
            <div className={styles['call-us']}>
                <div className={styles['call-us-content']}>
                    <div>
                        <div className={styles['title']}>{text[l]['title']}</div>
                        <div className={styles['line']}>&nbsp;</div>
                        {text[l]['map'].map(item => (
                            <div className={styles['item']}>
                                <span>{item.label}</span>:{` `}
                                <span>{item.value}</span>
                            </div>
                        ))}
                    </div>
                    <div>
                        <div className={styles['callus']}>{text[l]['callus']}</div>
                        <img src={qrcode} width={120} alt='' />
                    </div>
                </div>
                {/* <div className={styles['beian']}>© 2022 备案备案备案服务有限公司 版权所有｜ICP备17006647号-1</div> */}
                <div className={styles['beian']}>©2023 Prologue-Sports 版权所有</div>
            </div>
        </div>
    )
}

export default Fotter;